/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-10-08 16:43:36
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-03-25 15:08:51
 */
import crypto from 'crypto'
import common from './common'
import md5 from 'js-md5';
const Base64 = require('js-base64').Base64
var scrollTimer = null
/**
 * 对Date的扩展，将 Date 转化为指定格式的String
 * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q) 可以用 1-2 个占位符
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * eg:
 * (new Date()).pattern("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 * (new Date()).pattern("yyyy-MM-dd E HH:mm:ss") ==> 2009-03-10 二 20:09:04
 * (new Date()).pattern("yyyy-MM-dd EE hh:mm:ss") ==> 2009-03-10 周二 08:09:04
 * (new Date()).pattern("yyyy-MM-dd EEE hh:mm:ss") ==> 2009-03-10 星期二 08:09:04
 * (new Date()).pattern("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18
 */
export function formatDate(fmt, date) {

  if (date) {
    typeof date === 'string'&&date.indexOf('-')===-1&& (date = parseInt(date))
    if(typeof date === 'string'){
      //Android终端
      let isAndroid = /(Android)/i.test(navigator.userAgent);
　       //Ios终端
      let isiOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
      if(isiOS) {
          var date = new Date(date.replace(/-/g, "/"))
      }
      if(isAndroid){
          var date = new Date(date)
      }
    }else{
      var date = new Date(date)
    }
  } else {
    var date = new Date();
  }
  // %12 == 0 ? 12 : date.getHours()%12
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'H+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  var week = {
    "0": "日",
    "1": "一",
    "2": "二",
    "3": "三",
    "4": "四",
    "5": "五",
    "6": "六"
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '星期' : '周') : '') + week[date.getDay() + ''])
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
/**
 * format the phone to string
 * @param {(String|number)} phone
 * @returns {string | null}
 */
export function formatPhone(phone) {
  if (!phone) {
		return "--";
	}
	var str = String(phone);
	var len = str.length;
	var prev, next;
	if (len == 18) {
		prev = str.slice(-len, -17);
		next = str.slice(-1);
		str = prev + "**************" + next;
	} else if (len >= 7) {
		prev = str.slice(-len, -8);
		next = str.slice(-4);
		str = prev + "****" + next;
	} else if (len < 7 && len >= 6) {
		prev = str.slice(-len, -4);
		next = str.slice(-2);
		str = prev + "**" + next;
	}else if(len < 6) {
		prev = str.slice(-len, 1);
		str = prev + (len == 2?"*":'**' );
	}
	return str;
}

/**
 *
 * @param {*} date
 */
export function getYearMonthDay(date) {
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  if (month < 10) {
    month = '0' + month
  }
  return { year, month, day }
}
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    return value.toString().padStart(2, '0')
  })
  return timeStr
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * 获取userSig
 */
export function genTestUserSig(userID) {
  let SDKAPPID = process.env.TX_SDKAPPID
  let SECRETKEY = process.env.TX_SECRETKEY
  let EXPIRETIME = process.env.TX_EXPIRETIME
  var generator = new window.LibGenerateTestUserSig(SDKAPPID, SECRETKEY, EXPIRETIME)
  var userSig = generator.genTestUserSig(userID)
  return userSig
}

/**
 * 获取验证码时候使用的加密sign
 */
export function getSmsSign(phone, timestamp) {

  let sign = md5(
    Base64.encode(
      Base64.encode(
        md5(phone).toString() + md5(timestamp.toString()).toString()
      )
    )
  ).toString()
  return sign
}
/**
 * 利用 document.title 做新消息提示
 * @export
 * @param {Number} count
 */
export function titleNotify(count) {
  const hasNewMessage = count > 0
  if (hasNewMessage) {
    if (document.title.search(/\((.*?)\)/) >= 0) {
      document.title = document.title.replace(/\((.*?)\)/, `(${count > 99 ? '99+' : count})`)
    } else {
      document.title = `(${count})${document.title}`
    }
  } else {
    document.title = document.title.replace(/\((.*?)\)/, '')
  }
}
//获取身份证年月日
export function getBirt(idCard) {
  var birthday = "";
  if (idCard != null && idCard != "") {
    if (idCard.length == 15) {
      birthday = "19" + idCard.slice(6, 12);
    } else if (idCard.length == 18) {
      birthday = idCard.slice(6, 14);
    }
    //通过正则表达式来指定输出格式为:1990-01-01
    birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
    //转换成时间格式
    birthday = common.dateFormatByPhone(birthday)

  }
  return birthday;
}
//获取身份证的性别
export function getSex(idCard) {
  var sexStr = '';
  if (parseInt(idCard.slice(-2, -1)) % 2 == 1) {
    sexStr = 1;
  }
  else {
    sexStr = 2;
  }
  return sexStr;
}

export function scrollChatListDown(pos, initCount) {
  let dom = document.getElementById('app')
  if (!dom) {
    return
  }
  let maxCount = 5
  initCount = initCount || 1
  if (typeof pos !== 'number') {
    pos = Math.max(dom.scrollHeight - dom.clientHeight, 888888)
  }
  dom.scrollTop = pos
  if ((dom.scrollTop < pos) && (initCount < maxCount)) {
    clearTimeout(scrollTimer)
    scrollTimer = setTimeout(() => {
      initCount++
      scrollChatListDown(pos, initCount)
    }, 200)
  }
}
export function copy(string,callback){
            // var aux = document.createElement("input");
            // aux.setAttribute("value", string);
            // document.body.appendChild(aux);
            // aux.select();
            // document.execCommand("copy");
            // document.body.removeChild(aux);
            let textarea = document.createElement('textarea');
            textarea.id = "copyTextarea";
            textarea.style.width = 0;
            textarea.style.height = 0;
            document.body.appendChild(textarea);
            textarea = document.getElementById('copyTextarea');
            textarea.innerHTML = string;
            let isiOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
            if(isiOS){

            const range = document.createRange();
            range.selectNode(document.getElementById('copyTextarea'));
            const selection = window.getSelection();
            if (selection.rangeCount > 0) selection.removeAllRanges();
              selection.addRange(range);
            }else{
              textarea.select(); // 选中文本(select()方法对IOS部分版本无效)
            }
            document.execCommand('copy');
            document.body.removeChild(textarea);
            callback&&callback()
}
export function getUrlByWechat(url){
  return process.env.BASE_URL+'ms-patient-consummer/patientWechatArticle/1/requestProxy?url='+encodeURIComponent(url)
}

// 计算天数
export function lastTime(e){
  let time = e.replace(/-/g, "/")
  var now = new Date();
  var endDate = new Date(time);
  var leftTime=endDate.getTime()-now.getTime();
  var dd = parseInt(leftTime / 1000 / 60 / 60 / 24, 10)+'';//计算剩余的天数
  dd  = dd.replace(/-/g, "")
  var hh = parseInt(leftTime / 1000 / 60 / 60 % 24, 10)+"";//计算剩余的小时数
  hh  = hh.replace(/-/g, "")
  var mm = parseInt(leftTime / 1000 / 60 % 60, 10)+'';//计算剩余的分钟数
  mm  = mm.replace(/-/g, "")
  // let str = dd>0? (dd+ '天'):''
  // str+=   hh>0? (hh+ '小时'):''
  // str+=    mm+'分钟前最后申请'
  // str  = str.replace(/-/g, "")
  return dd
}

// 图片旋转处理 -> base64
export function rotateBase64Img(src, edg, callback){
  try {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  let imgW = 0 // 图片宽度
  let imgH = 0 // 图片高度
  let size = 0 // canvas初始大小

  if (edg % 90 !== 0) {
      throw new Error('旋转角度必须是90的倍数!')
  }

  (edg < 0) && (edg = (edg % 360) + 360)
  const quadrant = (edg / 90) % 4 // 旋转象限
  const cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 } // 裁剪坐标

  const image = new Image()
  image.src = src
  image.crossOrigin = 'anonymous'

  image.onload = function () {
      imgW = image.width
      imgH = image.height
      size = imgW > imgH ? imgW : imgH

      canvas.width = size * 2
      canvas.height = size * 2
      switch (quadrant) {
      case 0:
          cutCoor.sx = size
          cutCoor.sy = size
          cutCoor.ex = size + imgW
          cutCoor.ey = size + imgH
          break
      case 1:
          cutCoor.sx = size - imgH
          cutCoor.sy = size
          cutCoor.ex = size
          cutCoor.ey = size + imgW
          break
      case 2:
          cutCoor.sx = size - imgW
          cutCoor.sy = size - imgH
          cutCoor.ex = size
          cutCoor.ey = size
          break
      case 3:
          cutCoor.sx = size
          cutCoor.sy = size - imgW
          cutCoor.ex = size + imgH
          cutCoor.ey = size + imgW
          break
      }

      ctx.translate(size, size)
      ctx.rotate(edg * Math.PI / 180)
      ctx.drawImage(image, 0, 0)

      const imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey)
      if (quadrant % 2 === 0) {
          canvas.width = imgW
          canvas.height = imgH
      } else {
          canvas.width = imgH
          canvas.height = imgW
      }
          ctx.putImageData(imgData, 0, 0)

      if (typeof callback === 'function') {
          callback(canvas.toDataURL('image/png', 0.7))
      }
  }
  } catch (e) {
      console.log(e)
  }
}

export function base64ImgtoFile(dataurl, filename = "file") {
  let arr = dataurl.split(",");

  let mime = arr[0].match(/:(.*?);/)[1];

  let suffix = mime.split("/")[1];

  let bstr = atob(arr[1]);

  let n = bstr.length;

  let u8arr = new Uint8Array(n);

  while (n--) {
      u8arr[n] = bstr.charCodeAt(n);

  }

  return new File([u8arr], `${filename}.${suffix}`, {
      type: mime,

  });

}

export function iosTime(date){
  return new Date(date.replace(/-/g, '/'))
}

// * 获取url中的参数
export function getUrlParams(name){
  if (!name || name == '') {
    return false;
  }
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]); return false;
}

export function initMes (encryptedText) {
	const CryptoJS = require('crypto-js')
	const parts = encryptedText.split(":");
    const iv = CryptoJS.enc.Base64.parse(parts[0]);
    const ciphertext = parts[1];
    const key = CryptoJS.enc.Utf8.parse('bossplus20250718secretkey1234567');
    const decrypted = CryptoJS.AES.decrypt(ciphertext, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
}


// WEBPACK FOOTER //
// ./src/utils/index.js